import LazyImage from "@/my_components/Common/LazyImage";
import Link from "next/link";
import { ROUTE } from "@/route/app_routes.js";
import CourseHoverTooltip, { useCourseHoverTooltip } from "@/my_components/Common/CourseHoverTooltip";

// Reuses the exact .rbt-course-grid / .rbt-course-card classes from the homepage's
// "Featured courses" section (public/css/pages/HomeSections.css) -- one card design
// for the whole site instead of a second, differently-styled card here.
//
// Hover tooltip wired up the same way as FeaturedCourses.js/TrendingCourses.js: the shared
// useCourseHoverTooltip() hook tracks hover-intent + the hovered card's rect, `show`/`hide`
// go on the card's own onMouseEnter/onMouseLeave, and a single <CourseHoverTooltip> renders
// once per grid (not once per card) since it's positioned `fixed` off the hovered card's rect
// rather than nested inside any one card's DOM.
const CourseCardTwo = ({ course }) => {
  const { tooltip, show, hide, cancelHide } = useCourseHoverTooltip();

  return (
    <div className="rbt-course-grid">
      {course.map((data) => (
        <Link
          className="rbt-course-card"
          href={ROUTE.course_details + data.id}
          key={data.id}
          onMouseEnter={(e) => show(data, e.currentTarget)}
          onMouseLeave={hide}
        >
          <div className="rbt-course-card__media">
            <LazyImage
              src={data.course_image_big || data.course_image_small}
              alt={data.title}
              fill
              sizes="(max-width: 480px) 92vw, (max-width: 767px) 45vw, (max-width: 1199px) 30vw, 22vw"
            />
            <div className="rbt-course-card__badges">
              {data.category && <span className="rbt-course-card__tag">{data.category}</span>}
              <span className="rbt-course-card__free">Free</span>
            </div>
          </div>

          <div className="rbt-course-card__body">
            <div className="rbt-course-card__meta">
              <span><i className="feather-book"></i>{data.lessons} lessons</span>
              <span><i className="feather-users"></i>{data.students}</span>
            </div>

            <h3 className="rbt-course-card__title">{data.title}</h3>

            <div className="rbt-course-card__foot">
              {data.skill_level ? (
                <span className="rbt-course-card__level">{data.skill_level}</span>
              ) : (
                <span />
              )}
              <span className="rbt-course-card__cta">
                View course <i className="feather-arrow-right"></i>
              </span>
            </div>
          </div>
        </Link>
      ))}

      <CourseHoverTooltip tooltip={tooltip} onMouseEnter={cancelHide} onMouseLeave={hide} />
    </div>
  );
};

export default CourseCardTwo;
